import React from "react";
import dyslexiaIcon from "./icons/dyslexia.png";
import comprehensionIcon from "./icons/comprehension.png";
import decodingIcon from "./icons/decoding.png";
import phonemicIcon from "./icons/phonemic.png";
import recognitionIcon from "./icons/recognition.png";

export default function DomainIcon(props) {
  const { type } = props;

  return <img className="domain-icon" src={iconLookup[type]} />;
}

const iconLookup = {
  dyslexia: dyslexiaIcon,
  comprehension: comprehensionIcon,
  decoding: decodingIcon,
  phonemic: phonemicIcon,
  recognition: recognitionIcon,
};
